<template>
  <fragment>
    <AppBody
      title="Relatórios Analíticos"
      subtitle="Analítico"
      :actions="actions"
      :primaryLoading="$relatorios_sinteticos.loading_button_export_csv"
      :secondaryLoading="$relatorios_sinteticos.loading_button_export_pdf"
      disableDivider
    >
      <CardModule untitle>
        <v-form
          @submit.prevent="$relatorios_analiticos.filtroAnaliticoValidacao()"
          class="search-forms"
        >
          <v-row>
            <v-col cols="4" v-if="isAdmin">
              <BaseAutocomplete
                v-model="$relatorios_analiticos.filterValidacao.loja"
                :items="$relatorios_analiticos.lojas"
                placeholder="Selecione a Loja"
                :filter="searchLoja"
                item-text="nome_loja"
                required
                label="Loja"
                item-value="sequenciador"
                no-data-text="Nenhuma loja encontrada"
                clearable
                @click:clear="
                  $relatorios_analiticos.clearfilterValidacaoFields('loja')
                "
                :color="$config.dados.corinputs"
                :item-color="$config.dados.corinputs"
                :error-messages="
                  $relatorios_analiticos.filterValidacao.error.loja
                "
                @input="$relatorios_analiticos.filterValidacao.error.loja = []"
              >
                <template v-slot:selection="{ item }">
                  <div v-if="item ? (nome_loja = item) : null">
                    {{ item.nome_loja || item.razao_social }}
                  </div>
                </template>
                >
              </BaseAutocomplete>
            </v-col>
            <v-col cols="4">
              <BaseAutocomplete
                label="Produto"
                tabindex="2"
                placeholder="Selecione o Produto"
                :disabled="
                  $relatorios_analiticos.filterValidacao.loja !== null ||
                  !isAdmin
                    ? false
                    : true
                "
                :loading="$produtos_gerenciar.produtos_loading"
                clearable
                @click:clear="
                  $relatorios_analiticos.clearfilterValidacaoFields('produto')
                "
                :items="$produtos_gerenciar.produtos"
                v-model="$relatorios_analiticos.filterValidacao.produto"
                item-text="descricao"
                item-value="descricao"
                :filter="search"
              >
                <template v-slot:selection="{ item }">
                  <div v-if="item ? (produtos = item) : null">
                    {{ item.descricao }}
                  </div>
                </template>
                >
              </BaseAutocomplete>
            </v-col>
            <v-col cols="4">
              <BaseAutocomplete
                label="Consumidor"
                v-model="$relatorios_analiticos.filterValidacao.consumidor"
                :items="consumers"
                placeholder="Selecione o consumidor"
                item-text="nome"
                item-value="idconsumidor"
                :filter="searchConsumidor"
                clearable
                @click:clear="
                  $relatorios_analiticos.clearfilterValidacaoFields(
                    'consumidor'
                  )
                "
                :loading="$loja_consumidor.cadastro.loading_consumidores"
                :disabled="
                  $relatorios_analiticos.filterValidacao.loja !== null ||
                  !isAdmin
                    ? false
                    : true
                "
              >
                <template v-slot:selection="{ item }">
                  <div v-if="item ? (consumidores = item) : null">
                    {{ item.nome }}
                  </div>
                </template>
                >
              </BaseAutocomplete>
            </v-col>
            <v-col cols="4">
              <BaseSelect
                label="Intervalo de Datas"
                :items="$relatorios_analiticos.intervalo_data"
                item-text="text"
                item-value="value"
                v-model="$relatorios_analiticos.filterValidacao.intervalo_datas"
                placeholder="Selecione o intervalo de datas"
              />
            </v-col>
            <v-col
              cols="4"
              v-if="
                $relatorios_analiticos.filterValidacao.intervalo_datas !=
                'custom'
              "
            >
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <BaseTextField
                    label="Datas"
                    v-model="dateRangeText"
                    :append-icon="$config.icons.calendar"
                    readonly
                    :disabled="
                      $relatorios_analiticos.filterValidacao.intervalo_datas !=
                      null
                        ? false
                        : true
                    "
                    v-bind="attrs"
                    v-on="on"
                    :placeholder="placeholderData"
                    :color="$config.dados.corinputs"
                    clearable
                    @click:clear="
                      $relatorios_analiticos.clearfilterValidacaoFields(
                        'dates_validacao'
                      )
                    "
                    :error-messages="
                      $relatorios_analiticos.filterValidacao.error.range_dates
                    "
                    @input="
                      $relatorios_analiticos.filterValidacao.error.range_dates =
                        []
                    "
                  ></BaseTextField>
                </template>
                <v-date-picker
                  v-model="computeRange"
                  :active-picker.sync="activePicker"
                  @change="computeRange"
                  locale="pt"
                  @input="menu = false"
                  :header-color="$config.dados.corinputs"
                  :color="$config.dados.corinputs"
                  range
                  @click:month="monthEvent"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col v-else>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <BaseTextField
                    label="Datas"
                    v-model="dateRangeText"
                    :append-icon="$config.icons.calendar"
                    readonly
                    :disabled="
                      $relatorios_analiticos.filterValidacao.intervalo_datas !=
                      null
                        ? false
                        : true
                    "
                    v-bind="attrs"
                    v-on="on"
                    :error-messages="
                      $relatorios_analiticos.filterValidacao.error.range_dates
                    "
                    @input="
                      $relatorios_analiticos.filterValidacao.error.range_dates =
                        []
                    "
                    :placeholder="placeholderData"
                    :color="$config.dados.corinputs"
                    clearable
                    @click:clear="
                      $relatorios_analiticos.clearfilterValidacaoFields(
                        'dates_validacao'
                      )
                    "
                  ></BaseTextField>
                </template>
                <v-date-picker
                  v-model="$relatorios_analiticos.filterValidacao.range_dates"
                  :active-picker.sync="activePicker"
                  locale="pt"
                  @input="
                    $relatorios_analiticos.filterValidacao.range_dates.length ==
                    2
                      ? (menu = false)
                      : (menu = true)
                  "
                  :header-color="$config.dados.corinputs"
                  :color="$config.dados.corinputs"
                  range
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="4" class="d-flex justify-end" v-if="isAdmin">
              <BaseButton
                tabindex="13"
                variant="filter"
                class="button rounded-xxl"
                type="submit"
                :loading="$relatorios_analiticos.loading_button_validacao"
              >
                Filtrar
              </BaseButton>
            </v-col>
            <v-col cols="4" class="d-flex justify-end" v-if="!isAdmin">
              <BaseButton
                tabindex="13"
                variant="filter"
                class="button rounded-xxl"
                type="submit"
                :loading="$relatorios_analiticos.loading_button_validacao"
              >
                Filtrar
              </BaseButton>
            </v-col>
          </v-row>
        </v-form>
        <v-data-table
          class="rounded-lg"
          no-data-text="Não há registros."
          loading-text="Buscando informações...."
          :loading="$relatorios_analiticos.loading_relatorio_validacao"
          :headers="headers"
          :items="tableValues"
          :items-per-page="10"
          :custom-sort="$relatorios_sinteticos.customSort"
          :header-props="{
            class: 'rounded-t-lg',
            color: $config.dados.corinputs,
          }"
          :footer-props="{
            class: 'rounded-b-lg',
            itemsPerPageOptions: [10, 20, 50],
            itemsPerPageText: 'Produtos por página:',
          }"
        >
          <template v-slot:item.data_compra="{ item }">
            {{ item.data_compra | data_pt_br }}
          </template>
        </v-data-table>
        <v-data-table
          class="rounded-lg"
          :header-props="{
            class: 'rounded-t-lg',
            color: $config.dados.corinputs,
          }"
          :footer-props="{
            class: 'rounded-b-lg',
          }"
          hide-default-footer
          no-data-text="Não há registros."
          loading-text="Buscando informações...."
          :loading="$relatorios_analiticos.loading_relatorio_validacao"
          :headers="headersTotais"
          :items="totalTableValues"
        >
        </v-data-table>
      </CardModule>
    </AppBody>
  </fragment>
</template>
<script>
import dayjs from "dayjs";
import CardModule from "@/components/cards/CardModule.vue";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseAutocomplete from "@/components/forms/BaseAutocomplete.vue";
import AppBody from "@/layouts/components/AppBody.vue";
import BaseButton from "@/components/forms/BaseButton.vue";
export default {
  name: "ValidationAnalytical",
  metaInfo: {
    title: "Relatório Analítico Validação | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Relatório Analítico Validação | ElevenTickets",
      },
    ],
  },
  props: {},
  components: {
    CardModule,
    BaseSelect,
    BaseTextField,
    BaseAutocomplete,
    BaseButton,
    AppBody,
  },
  data() {
    return {
      actions: [
        {
          id: "CSV",
          name: "Exportar Excel/CSV",
          action: () => this.exportCSV(),
        },
        {
          id: "PDF",
          name: "Imprimir/Exportar PDF",
          action: () => this.exportAction(),
        },
      ],
      dayjs: dayjs,
      headers: [
        {
          text: "Data de Compra",
          align: "center",
          sortable: false,
          value: "data_compra",
          width: 200,
        },
        {
          text: "Mídia",
          align: "center",
          sortable: false,
          value: "midia",
          width: 150,
        },
        {
          text: "Consumidor",
          align: "center",
          value: "consumidor",
          width: 180,
        },
        {
          text: "Produto",
          align: "center",
          value: "produto",
          width: 150,
        },
        {
          text: "Validações",
          align: "center",
          value: "qtd_acessos",
          width: 180,
        },
        {
          text: "Disponíveis",
          align: "center",
          value: "acessos_disp",
          width: 180,
        },
        // {
        //   text: "Status",
        //   align: "center",
        //   value: "status",
        //   width: 180,
        // },
        {
          text: "Usuário Validação",
          align: "center",
          value: "usuario_validacao",
          width: 200,
        },
      ],
      headersTotais: [
        {
          text: "Total Itens Vendidos",
          align: "center",
          sortable: false,
          value: "qtd_itens",
          width: 200,
        },
        {
          text: "Total de Validações",
          align: "center",
          sortable: false,
          value: "total_acessos",
          width: 150,
        },
        {
          text: "Itens com validação parcial",
          align: "center",
          sortable: false,
          value: "total_itens_acesso_parc",
          width: 180,
        },
        {
          text: "Validações Disponíveis",
          align: "center",
          sortable: false,
          value: "acessos_disp",
          width: 150,
        },
      ],
      activePicker: null,
      date: null,
      menu: false,
      placeholderData: "dd/mm/aa ~ dd/mm/aa",
      disableRegionais: false,
      produtos: [],
    };
  },
  watch: {
    "$relatorios_analiticos.filterValidacao.loja"(e) {
      if (e === null || e === undefined || e === "") {
        this.disableRegionais = false;
        return;
      } else {
        this.disableRegionais = true;
        this.$produtos_gerenciar.getProdutos(e);
        this.$loja_consumidor.getConsumidor(e);
      }
    },
    "$relatorios_analiticos.filterValidacao.intervalo_datas"(e) {
      switch (e) {
        case "date": {
          const currentDay = new Date(
            Date.now() - new Date().getTimezoneOffset() * 60000
          )
            .toISOString()
            .substr(0, 10);
          // const day = new Date(new Date(currentDay).setDate(new Date(currentDay).getDate() + 1)).toISOString().slice(0, 10);
          this.$relatorios_analiticos.filterValidacao.range_dates = [
            currentDay,
            currentDay,
          ];
          break;
        }
        case "week": {
          const currentDayWeek = this.dayjs().day(0).format("YYYY-MM-DD");
          const week = this.dayjs().day(6).format("YYYY-MM-DD");
          this.$relatorios_analiticos.filterValidacao.range_dates = [
            currentDayWeek,
            week,
          ];
          break;
        }
        case "month": {
          const currentDayMonth = this.dayjs()
            .startOf("month")
            .format("YYYY-MM-DD");
          const month = this.dayjs().endOf("month").format("YYYY-MM-DD");
          this.$relatorios_analiticos.filterValidacao.range_dates = [
            currentDayMonth,
            month,
          ];
          break;
        }
        case "custom": {
          const currentDayCustom = new Date(
            Date.now() - new Date().getTimezoneOffset() * 60000
          )
            .toISOString()
            .substr(0, 10);
          const custom = new Date(
            new Date(currentDayCustom).setDate(
              new Date(currentDayCustom).getDate() + 1
            )
          )
            .toISOString()
            .slice(0, 10);
          this.$relatorios_analiticos.filterValidacao.range_dates = [
            currentDayCustom,
            custom,
          ];
          break;
        }
        default: {
          const defaultDay = new Date(
            Date.now() - new Date().getTimezoneOffset() * 60000
          )
            .toISOString()
            .substr(0, 10);
          const defaultDayCustom = new Date(
            new Date(defaultDay).setDate(new Date(defaultDay).getDate() + 1)
          )
            .toISOString()
            .slice(0, 10);
          this.$relatorios_analiticos.filterValidacao.range_dates = [
            defaultDay,
            defaultDayCustom,
          ];
          break;
        }
      }
    },
    menu(val) {
      val &&
        setTimeout(() => {
          if (
            val &&
            this.$relatorios_analiticos.filterValidacao.intervalo_datas ==
              "date"
          ) {
            this.activePicker = "DATE";
          } else if (
            val &&
            this.$relatorios_analiticos.filterValidacao.intervalo_datas ==
              "week"
          ) {
            this.activePicker = "DATE";
          } else if (
            val &&
            this.$relatorios_analiticos.filterValidacao.intervalo_datas ==
              "month"
          ) {
            this.activePicker = "MONTH";
          } else if (
            val &&
            this.$relatorios_analiticos.filterValidacao.intervalo_datas ==
              "custom"
          ) {
            this.activePicker = "DATE";
          } else {
            this.activePicker = "DATE";
          }
        });
    },
    dateRangeText(e) {
      if (e) {
        this.$relatorios_analiticos.filterValidacao.error.range_dates = [];
      }
    },
  },
  methods: {
    searchLoja(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.nome_loja.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
    monthEvent(month) {
      const currentDayMonth = this.dayjs(month)
        .startOf("month")
        .format("YYYY-MM-DD");
      const monthEnd = this.dayjs(month).endOf("month").format("YYYY-MM-DD");
      this.$relatorios_analiticos.filterValidacao.range_dates = [
        currentDayMonth,
        monthEnd,
      ];
    },
    replaceSpecialChars(str) {
      str = str.replace(/[ÀÁÂÃÄÅ]/, "A");
      str = str.replace(/[àáâãäå]/, "a");
      str = str.replace(/[ÈÉÊË]/, "E");
      str = str.replace(/[Ç]/, "C");
      str = str.replace(/[ç]/, "c");
      // o resto
      return str.replace(/[^a-z0-9]/gi, "");
    },
    search(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.descricao.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
    searchConsumidor(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.nome.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
    exportCSV() {
      this.$relatorios_analiticos.imprimirCSVValidacao();
    },
    exportAction() {
      this.$relatorios_analiticos.imprimirPDFValidacao();
    },
  },
  computed: {
    consumers() {
      const consumidor = this.$loja_consumidor.consumidores;

      consumidor.forEach(item => {
        item.nome = item.nome || item.razao_social;
      });
      return consumidor;
    },
    tableValues() {
      return this.$relatorios_analiticos.relatorio_validacao;
    },
    totalTableValues() {
      return this.$relatorios_analiticos.relatorio_validacao_totais;
    },
    computeRange: {
      get() {
        return this.$relatorios_analiticos.filterValidacao.range_dates;
      },
      set([firstDay]) {
        switch (this.$relatorios_analiticos.filterValidacao.intervalo_datas) {
          case "date":
            // const day = new Date(new Date(firstDay).setDate(new Date(firstDay).getDate() + 1)).toISOString().slice(0, 10);
            this.$relatorios_analiticos.filterValidacao.range_dates = [
              firstDay,
              firstDay,
            ];
            break;
          case "week": {
            const currentDayWeek = this.dayjs(firstDay)
              .day(0)
              .format("YYYY-MM-DD");
            const week = this.dayjs(firstDay).day(6).format("YYYY-MM-DD");
            this.$relatorios_analiticos.filterValidacao.range_dates = [
              currentDayWeek,
              week,
            ];
            break;
          }
          case "month": {
            const currentDayMonth = this.dayjs(firstDay)
              .startOf("month")
              .format("YYYY-MM-DD");
            const month = this.dayjs(firstDay)
              .endOf("month")
              .format("YYYY-MM-DD");
            this.$relatorios_analiticos.filterValidacao.range_dates = [
              currentDayMonth,
              month,
            ];
            break;
          }
          case "custom": {
            const currentDayCustom = new Date(
              Date.now() - new Date().getTimezoneOffset() * 60000
            )
              .toISOString()
              .substr(0, 10);
            const custom = "";
            this.$relatorios_analiticos.filterValidacao.range_dates = [
              currentDayCustom,
              custom,
            ];
            break;
          }
          default: {
            const defaultDay = "";
            this.$relatorios_analiticos.filterValidacao.range_dates = [
              firstDay,
              defaultDay,
            ];
            break;
          }
        }
      },
    },
    dateRangeText() {
      let arrayDates = [];
      this.$relatorios_analiticos.filterValidacao.range_dates.forEach(item => {
        return arrayDates.push(this.$config.convertDataBR(item));
      });

      return arrayDates.join(" ~ ");
    },
    isAdmin() {
      if (this.$axios.getLocal("oe_user_info").data.user_type === "admin")
        return true;
      return false;
    },
  },
  mounted() {
    // this.$pessoas_agentes.getAgentes();
    if (!this.isAdmin) {
      this.$relatorios_analiticos.filterValidacao.loja =
        this.$axios.getLocal("oe_user_info")?.data?.loja;
      this.$relatorios_analiticos.filtroAnaliticoValidacao();
      this.$produtos_gerenciar.getProdutos(
        this.$axios.getLocal("oe_user_info")?.data?.loja
      );
      return;
    }
    this.$loja_gerenciar.getRegionais();
    this.$relatorios_analiticos.getAllLojas();
  },
  destroyed() {
    this.$relatorios_analiticos.limpaFiltrosValidacao();
  },
};
</script>
<style scoped></style>
